import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';
function AddMunicipio({ handleNewMunicipio, editMunicipio }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [pais, setPais] = useState('');
    const [depto, setDepto] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [deptos, setDeptos] = useState([]);
    const [paises, setPaises] = useState([]);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();
    useEffect(() => {
        if (editMunicipio) {
            setMunicipio(editMunicipio.nombreMunicipio);
            setDepto(editMunicipio.idDepartamento);
            setPais(editMunicipio.idPais);
            setIngresadoPor(editMunicipio.ingresadoPor);
            setModificacion(2);
        } else {
            setMunicipio('');
            setDepto('');
            setPais('');
            setModificacion(1);
            setIngresadoPor('');

        }
    }, [editMunicipio]);

    useEffect(() => {
        const fetchPaises = async () => {
            try {
                const response = await fetch(`${server}/MgPaises`);
                const data = await response.json();
                setPaises(data.$values);
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar los paises: ' + error,
                });
            }
        };
        fetchPaises();
    }, []);

    useEffect(() => {
        const fetchDepartamentos = async () => {
            if (pais) {
                try {
                    const response = await fetch(`${server}/MgDepartamentoes/departamentosbypais/${pais}`);
                    const data = await response.json();
                    setDeptos(data.$values);
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar los Departamentos: ' + error,
                    });
                }
            } else {
                setDeptos([]);
            }
        };
        fetchDepartamentos();
    }, [pais]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editMunicipio ? 'PUT' : 'POST';
        const endpoint = editMunicipio ? `${server}/MgMunicipios/${editMunicipio.idMunicipio}` : `${server}/MgMunicipios`;

        const nuevoMunicipio = {
            idMunicipio:editMunicipio ? editMunicipio.idMunicipio : 0,
            idDepartamento:depto,
            nombreMunicipio:municipio,
            IngresadoPor: !editMunicipio ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editMunicipio ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
           
        };
        Object.keys(nuevoMunicipio).forEach(key => nuevoMunicipio[key] === undefined && delete nuevoMunicipio[key]);
       
        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(nuevoMunicipio),
            });

            if (response.ok) {
                setPais('');
                setDepto('');
                setMunicipio('');
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
                handleNewMunicipio();
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            console.error('Error al guardar el municipio:', error);
           
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar el municipio',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };

    return (
        <>
            <h2>{editMunicipio ? 'Editar Municipio' : 'Agregar Nuevo Municipio'}</h2>
            <br />
            <form onSubmit={handleSubmit} data-parsley-validate className="form-horizontal form-label-left">
                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="Empresa">País</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={pais} onChange={(e) => setPais(e.target.value)}>
                            <option value="">Elija una opción</option>
                            {paises.map((pais) => (
                                <option key={pais.idPais} value={pais.idPais}>{pais.nombrePais}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="Empresa">Departamento</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={depto} onChange={(e) => setDepto(e.target.value)}>
                            <option value="">Elija una opción</option>
                            {deptos.map((depto) => (
                                <option key={depto.idDepartamento} value={depto.idDepartamento}>{depto.nombreDepartamento}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="nombrePerfil">Nombre Municipio:</label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="nombrePerfil"
                            required="required"
                            className="form-control"
                            value={municipio}
                            onChange={(e) => setMunicipio(e.target.value)}
                        />
                    </div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Municipio')}>{editMunicipio ? 'Actualizar' : 'Guardar'}</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddMunicipio;
